import { useState } from "react";
import API from "../api/api";
import toast from "react-hot-toast";

export default function Checkin() {
  const [id, setId] = useState("");
  const [damageCost, setDamageCost] = useState(0);

  const handleCheckin = async () => {
    try {
      await API.patch(`/checkin/${id}`, {
        damageCost
      });

      toast.success("Inchecken afgerond");
    } catch {
      toast.error("Inchecken mislukt");
    }
  };

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Inchecken</h1>
          <p className="page-subtitle">Rond een terugname af en registreer schade indien nodig.</p>
        </div>
      </header>

      <div className="panel panel-pad action-card">
        <div className="form-grid">
          <input
            className="input"
            placeholder="Reservatie ID"
            onChange={(e) => setId(e.target.value)}
          />

          <input
            className="input"
            placeholder="Schadekost"
            type="number"
            onChange={(e) => setDamageCost(e.target.value)}
          />

          <button className="button" onClick={handleCheckin}>
            Inchecken bevestigen
          </button>
        </div>
      </div>
    </section>
  );
}
